import React from 'react';
import styled, { css } from 'styled-components';
import useTooltipLayer from '~/hooks/useTooltipLayer';

const text = {
  requiredField: 'Dit veld is verplicht',
};

export type Props = {
  dataTestId?: string;
  className?: string;
};

const RequiredMark: React.FCC<Props> = ({ dataTestId, className }) => {
  const tooltipProps = useTooltipLayer({ tooltipMessage: text.requiredField });

  return (
    <Mark data-testid={dataTestId} className={className} {...tooltipProps}>
      *
    </Mark>
  );
};

const Mark = styled.sup(
  ({ theme }) => css`
    color: ${theme.color('accent')};
    vertical-align: top;
    cursor: pointer;
    font-size: inherit;
    top: ${theme.space('xxs')};
    margin-left: 0.2em;
  `,
);
export default RequiredMark;
